<template>
  <div class="prop" :class="cssType + ' ' + size + ' ' + locale">
    <div class="prop-icon-wrap">
      <div class="prop-icon" :class="`icon-${props.item.propId}`"></div>
    </div>
    <div class="prop-name">{{ $t(`poolParty.prop.${props.item.propId}`) }} * {{ props.item.count || 1 }}</div>
  </div>
</template>

<script setup>
import { isMobile } from '@/utils'
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
const cssType = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
const props = defineProps({
  item: {
    type: Object,
    default: () => {}
  },
  size: {
    type: String,
    default: 'normal' // normal, small
  }
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>